module.exports = __webpack_public_path__ + "static/media/inserirEstoque.a7f42880.jpg";